export default "__VITE_ASSET__DhveaRle__"